import CryptoJS from "crypto-js";

export const encryptData = (data) => {
  const encryptData = CryptoJS.AES.encrypt(
    data,
    process.env.REACT_APP_SOCKET_SECRET_KEY
  ).toString();
  return encryptData;
};
export const decryptData = (encryptedData) => {
  try {
    if (!encryptedData) throw new Error("No data provided for decryption.");

    const bytes = CryptoJS.AES.decrypt(
      encryptedData,
      process.env.REACT_APP_SOCKET_SECRET_KEY
    );
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedText) throw new Error("Decryption failed, data is empty.");

    return JSON.parse(decryptedText);
  } catch (error) {
    console.error("Error during decryption:", error.message);
    console.error("Encrypted Data:", encryptedData);
    throw new Error("Invalid encrypted data or secret key mismatch.");
  }
};
